/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../base/BaseComponent";
import { Popover, Modal} from "antd";
import Position from '../../../components/Position'
import ChoiceType from '../../../components/ChoiceType'
import {changeSize, formatTime, uuid} from '../../../../../utils'
import {message} from '../../../components/Mess'
import '../../../style/public.css'
import PageTableComponent from "../../../components/pageTable/PageTable";
import Detailpage from "../../../components/DetailPage";
import {AUDIO_TYPE, HEADER_HEIGHT, PIC_TYPE, VIDEO_TYPE} from "../../../../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import $ from "jquery";
const {confirm} = Modal;


export default class Share extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {

            selectType: [],//选中的类型
            searchText: '',//搜索的文字
            startTime: '',//开始时间
            endTime: '',//结束时间
            page: 1,
            size: 10,
            data: [],
            count: 0,
            currentId: '',
            RootId: '',
            first: true,
            modalKey:uuid()

        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getList();
         this.getPosition()
    }

    render() {

        return (
            <div style={{background: '#ffffff',
                margin: "15px 0 15px 15px",
                padding: '24px 32px 16px 32px',
                position: 'relative',
                borderRadius:5}}>
                {/*渲染选择框以及下载 功能*/}
                {this.renderBtn()}
                {/*渲染当前位置*/}
                {this.renderPosition()}
                {/*渲染数据*/}
                {this.renderData()}
            </div>
        )
    }

    renderBtn() {
        return (
            <div style={{display: this.state.first ? "":"none" }}>
                <ChoiceType onSaveCallback={(searchText, selectType, startTime, endTime) => {
                    this.setState({
                        searchText: searchText,
                        selectType: selectType,
                        startTime: startTime,
                        endTime: endTime,
                        page:1,
                    }, () => {
                        this.getList()
                    })
                }}></ChoiceType>
            </div>


        )
    }

    renderData() {
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        let key = {
            nameKey: 'name',
            sizeKey: 'size'
        };
        if (this.state.first) {
            key = {
                nameKey: 'resourceName',
                sizeKey: 'resourceSize'
            }
        }
        let columns = [
            {
                title: '名称',
                dataIndex: 'resourceName' || 'name',
                width:this.state.first?300:'80%',
                ellipsis: true,
                render: (text, record) => {
                    let title =text;
                    if(this.state.first){
                        title =record.resourceName
                    }else{
                        title =record.name
                    }
                    return (<div style={{display: 'flex', cursor: 'pointer'}} onClick={() => {
                        this.nameClick(record)
                    }}>
                        <div>
                            <img src={record.icon} style={{width: '24px', height: '24px', objectFit: "contain"}}/>
                        </div>
                            <div
                                title={title}
                                style={{
                                    color: "rgba(0, 0, 0, 0.85)",
                                    width: this.state.first?200:'90%',overflow: 'hidden', whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    fontSize: "16px",
                                    marginLeft: '8px'
                                }}>{record[key.nameKey]}</div>
                        </div>
                   )
                }
            }
        ];
        if (this.state.first) {
            columns.push({
                title: this.props.type?'分享自':'分享至',
                width:400,
                render: (text, record) => {
                    let array =[];
                   if(record&&record.shareNameList&&record.shareDeptNameList){
                      record.shareNameList.forEach((item,index)=>{
                          array.push({
                              name:item,
                              dep:record.shareDeptNameList[index]
                          })
                       })
                   }
                    let content = <Scrollbars  autoHeight  autoHeightMin={25}
                                 autoHeightMax={400} style={{width:'400px'}}>
                                {array&&array.length&&array.map((item,index)=>{
                                if (index === array.length - 1) {
                                    return (<span style={{padding:'5px'}} key={item.name}><span>{item.name}</span><span>（{item.dep}）</span></span>)
                                }else{
                                    return (<span style={{padding:'5px'}} key={item.name}><span>{item.name}</span><span>（{item.dep}），</span></span>)
                                }
                            })}</Scrollbars>;
                    return (<div >
                         <Popover content={content}  trigger="hover" >
                            <div style={{display: 'flex'}} >
                                <div style={{maxWidth:'150px'}} className={'twoText'}>
                                    {record.shareNameList && record.shareNameList[0]}
                                </div>
                                <div style={{marginLeft: 5,maxWidth:'150px'}} className={'twoText'}>
                                    （{record.shareDeptNameList && record.shareDeptNameList[0]}）
                                </div>
                                {record.shareUserNum > 1?<div style={{marginLeft: 5}}> 等{record.shareUserNum}个用户</div>:null}
                            </div>
                        </Popover>

                    </div>)
                }
            });
            columns.push({
                title: '分享时间',
                width:200,
                dataIndex: 'shareTime',
                render: (text, record) => {
                    return (<div>{formatTime(text)}</div>)
                }
            })
        }
        columns.push(
            {
                title: '大小',
                render: (text, record) => {
                    if(record.fileTypeEnum==='DIR'||record.fileTypeEnum==='LINK'){
                        return (<div style={{textIndent:'13px'}}>{'-'}</div>)
                    }else{
                        let text =text
                        if(this.state.first){
                            console.log()
                            text=record.resourceSize
                        }else{
                            text=record.size
                        }
                        return (<div>{text>0?changeSize(text):0+'b'}</div>)
                    }
                }
            },
        );
        if(this.props.type){
            columns.push({
                title: '操作',
                dataIndex: 'option',
                render: (text, record) => {
                    console.log(record)
                    return (<div style={{color:newSecondSelectColor}}>

                        {this.props.type&&record.fileTypeEnum === "FILE" ?<span style={{cursor: "pointer"}} onClick={() => {
                            this.downLoad(record)
                        }}>下载</span>:''}
                    </div>)
                }

            })
        }
        if(!this.props.type&&this.state.first)
        columns.push({
            title: '操作',
            dataIndex: 'option',
            render: (text, record) => {
                return (<div style={{color:newSecondSelectColor}}>
                  <span style={{cursor: "pointer"}} onClick={() => {
                        this.cancelShare(record)
                    }}>取消分享</span>
                </div>)
            }
        })


        // if (this.state.first) {
        //     columns.push({
        //         title: '操作',
        //         dataIndex: 'option',
        //         render: (text, record) => {
        //             return (<div style={{color: '#0050B3',}}>
        //                 {this.props.type?<span style={{cursor: "pointer"}} onClick={() => {
        //                     this.downLoad(record)
        //                 }}>下载</span>:<span style={{cursor: "pointer"}} onClick={() => {
        //                     this.cancelShare(record)
        //                 }}>取消分享</span>}
        //             </div>)
        //         }
        //     })
        // }
        const positionHeight=45;
        return (
            <div>
                <PageTableComponent
                    positionHeight={positionHeight}
                    columns={columns}
                    rowSelection={null}
                    data={this.state.data}
                    page={this.state.page}
                    size={this.state.size}
                    count={this.state.count}
                    onChangePage={(page, size) => {
                        this.onChangePage(page, size)
                    }}
                ></PageTableComponent>
                <Detailpage   key={this.state.modalKey} onRef={(Detailpage) => this.setDetailpage = Detailpage}
                              onCloseCall={() => {
                                  this.setState({modalKey: uuid()})
                              }}
                              dataList={this.state.data}></Detailpage>
            </div>

        )
    }

    nameClick(record){
        if(this.state.first){
            this.state.RootId =  record.virtualFileId;
            this.state.currentId =record.virtualFileId;
        }else{
            this.state.currentId =record.id;
        }
        if (record.fileTypeEnum === 'DIR'||record.fileTypeEnum==='LINK') {
            this.setState({page: 1, first: false});
            this.getTwoList()
        }else{
            this.getDetailPage(record)
        }
    }
    //详情页
    getDetailPage(item) {
        this.setDetailpage.show(true,item);
        if(this.props.type){
            this.setDetailpage.getTable()
        }

    }

    onChangePage(page, size) {
        this.setState({page: page, size: size}, () => {
            this.getList()
        })
    }

    //下载
    downLoad(record){

        this.request({
            url: "/cm-sites-storage-management/zykDownLoad/addZykDownLoad",
            method: "post",
            body:{virtualFileId:this.state.first?record.virtualFileId:record.id,name:this.state.first?record.resourceName:record.name, downloadFlag:false},
            contentType:'json',
            callBack: (data) => {
                if(data){
                    let url =  "/storage/downloadFile?md5="+data.md5+'&download=1';
                    let aObj = document.createElement('a');
                    aObj.setAttribute('download','');
                    aObj.setAttribute('href',url);
                    aObj.click();
                    aObj = null
                }
                let fileType = '';
                if(PIC_TYPE.indexOf(record.suffix)>-1) {
                    fileType = 1;
                }else if(VIDEO_TYPE.indexOf(record.suffix)>-1){
                    fileType = 2;
                }else if(AUDIO_TYPE.indexOf(record.suffix)>-1){
                    fileType = 3;
                }else {
                    fileType = 4;
                }
                let body = {
                    id:record.virtualFileId,
                    fileName:record.name,   //String 文件名称
                    fileIcon:record.icon,   //String 文件显示缩略图
                    type:fileType,        //Integer 文件类型 参考前面保持一致
                    md5:record.md5,         //String 文件的md5
                    size:record.size,        //long  文件大小
                }
                this.request({
                    url: "/cm-sites-storage-management/zykStatistics/addDownloadRecords",
                    method: "post",
                    body:body,
                    contentType:'json',
                })
            }
        });
    }

    cancelShare(record) {
        confirm({
            title: '确定要取消分享所选项？',
            onOk: () => {
                this.request({
                    url: "/cm-sites-storage-management/zykShare/cancel",
                    method: "get",
                    body: {virtualFileId: record.virtualFileId, shareTime: record.shareTime},
                    callBack: (data) => {
                        let page;
                        if (data) {
                             message.success('取消分享成功');
                            if (this.state.data.length === 1) {
                                page = this.state.page - 1;
                                this.onChangePage(this.state.page - 1, this.state.size)
                            } else {
                                page = this.state.page;
                            }
                            this.setState({first:true},()=>{
                                this.onChangePage(page, this.state.size)
                            });
                        }
                    }
                });
            },
            onCancel() {
            },
        });

    }

    getTwoList() {
        window.loading.show(true);
        let parms = {
            fid: this.state.currentId,
            page: this.state.page,
            size: this.state.size,
        };
        this.request({
            url: "/cm-sites-storage-management/zykShare/shareSonList", method: "get", body: parms,contentType:'json', callBack: (data) => {
                window.loading.hide();
                this.setState({data: data.data, count: data.count},()=>{
                    $('.ant-pagination-options-quick-jumper').find('input').val('')
                });
                this.setPosition.getPosition(this.state.currentId, this.state.RootId, this.props.backList, true)
            }
        });
    }

    renderPosition() {
        return (
            <div style={{marginTop:24}}>
            <Position onRef={(position) => this.setPosition = position}
                      virtualFileId={this.state.currentId}
                      id={this.state.id}
                      onSaveCallback={(id) => {
                          if(id === 0){
                              this.setState({ currentId:'',RootId:'',first: true,page:1}, () => {
                                  this.getList()
                              })
                          }else{
                              this.setState({currentId: id, first: false,page:1}, () => {
                                  this.getTwoList()
                              })
                          }
                      }}
            ></Position></div>
        )
    }
    getList() {
        window.loading.show(true);
        let parms = {};
        if (this.state.selectType.length) {
            parms.suffix = this.state.selectType
        }
        if (this.state.searchText) {
            parms.resourceName = this.state.searchText
        }
        if (this.state.startTime) {
            let shareTme = {
                startTime: this.state.startTime,
                endTime: this.state.endTime
            };
            parms.shareTime = shareTme
        }
        this.request({
            url: '/cm-sites-storage-management/zykShare/' + this.props.url +'?page='+ this.state.page + '&size=' + this.state.size,
            method: "post",
            body: parms,
            contentType: "json",
            callBack: (data) => {
                window.loading.hide();
                if (data) {
                    this.setState({data: data.data, count: data.count},()=>{
                        $('.ant-pagination-options-quick-jumper').find('input').val('')
                    });
                }
            }
        });
    };
    getPosition(){
        this.setPosition.getPosition(this.state.currentId, this.state.RootId, this.props.backList)
    }


}